// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_gx-0";
export var headerCellHover = "_gx-1";
export var readCellContainer = "_gx-2";
export var unreadIndicator = "_gx-3";